import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { useTheme } from '../../theming/useTheme';
import { ErrorBoundary } from '../errorHandling/ErrorBoundary';
import { MandatoryAdditionalStyle, Style } from '../components.utils';

const componentConfigurationKey = 'divider';

interface DividerDataProps {
  dataId?: string
}

interface DividerThemeProps {
  color: string
}

const mapThemeToProps = (theme: DividerThemeProps) => ({
  color: theme.color,
});

type DividerComponentProps = DividerThemeProps & MandatoryAdditionalStyle & DividerDataProps;

type DividerProps = MandatoryAdditionalStyle & DividerDataProps;

const createStyle = ({ color }: DividerThemeProps) => StyleSheet.create({
  divider: {
    backgroundColor: color,
    width: 'auto',
    height: '1px',
  },
});


export const DividerComponent: React.FunctionComponent<DividerComponentProps> = props => {
  const style = createStyle(props);
  const { additionalStyle, dataId } = props;
  return <div data-id={dataId} className={css(style.divider, additionalStyle.style as Style)} />;
};

export const Divider = (props: DividerProps) => {
  const themeContext = useTheme(mapThemeToProps, componentConfigurationKey);
  return <ErrorBoundary><DividerComponent {...themeContext} {...props} /></ErrorBoundary>;
};
